import { useMobile } from "../../hooks/UseMobileSidebar";
import DesktopNavbar from "./desktop/DesktopNavbar";
import MobileNavbar from "./mobile/MobileNavbar";

function Navbar() {
  const { isMobile } = useMobile();
  return isMobile ? <MobileNavbar /> : <DesktopNavbar />;
}

export default Navbar;
